import { IRoundDocumentMetadata } from '../../../data-models/round-document.data-model';

export const fixtureRoundDocument = (
  overrides: Partial<IRoundDocumentMetadata> = {}
): IRoundDocumentMetadata => ({
  id: 1,
  roundId: 10,
  documentType: 'closing_doc',
  fileName: 'doc.pdf',
  fileSize: '1.00 MB',
  contentType: 'application/pdf',
  uploadedBy: 'ops@example.com',
  uploadSource: 'maggie',
  createdAt: '2026-05-16T14:02:00Z',
  updatedAt: '2026-05-16T14:02:00Z',
  ...overrides,
});

const extracted = {
  processingStatus: 'processed',
  parsingStatus: 'parsed',
  mappingStatus: 'mapped',
} as const;

/** A well-covered round for the frosted preview: the closing set extracted, one file still processing. */
export const PREVIEW_ROUND_DOCUMENTS: IRoundDocumentMetadata[] = [
  fixtureRoundDocument({
    id: -1,
    roundId: -1,
    fileName: 'Series_C_Stock_Purchase_Agreement.pdf',
    fileSize: '2.41 MB',
    ...extracted,
  }),
  fixtureRoundDocument({
    id: -2,
    roundId: -1,
    fileName: 'Series_C_Investors_Rights_Agreement.pdf',
    fileSize: '1.87 MB',
    ...extracted,
  }),
  fixtureRoundDocument({
    id: -3,
    roundId: -1,
    fileName: 'Series_C_Voting_Agreement.pdf',
    fileSize: '1.12 MB',
    ...extracted,
  }),
  fixtureRoundDocument({
    id: -4,
    roundId: -1,
    fileName: 'Series_C_ROFR_and_Co-Sale_Agreement.pdf',
    fileSize: '1.34 MB',
    processingStatus: 'processed',
    parsingStatus: 'pending',
    createdAt: '2026-05-18T09:30:00Z',
    updatedAt: '2026-05-18T09:30:00Z',
  }),
  fixtureRoundDocument({
    id: -5,
    roundId: -1,
    fileName: 'Amended_and_Restated_Charter.pdf',
    fileSize: '0.96 MB',
    ...extracted,
  }),
  fixtureRoundDocument({
    id: -6,
    roundId: -1,
    documentType: 'captable',
    fileName: 'Post_Series_C_Cap_Table.xlsx',
    fileSize: '84.00 KB',
    contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    processingStatus: 'processed',
  }),
];
